import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { apiRequest } from "../apiService/allApi";
import Swal from "sweetalert2";

function EmailVerification() {
  const navigate = useNavigate();
  const { token } = useParams();
  const [loading, setLoading] = useState(false);

    const verifyEmail = async () => {
      if (!token) return;

      setLoading(true);

      try {
        const response = await apiRequest(
          `api/customer/register/${token}`,
          "POST",
          {}
        );

        if (response?.data) {

          Swal.fire({
            icon: "success",
            text: response?.data?.message,
          });

          // ✅ Optional redirect after verification
          navigate("/login");
        }
      } catch (e) {
        console.error(e);
        console.log(e.response?.data, "vikash");
      } finally {
        setLoading(false);
      }
    };
  // 🔹 EMAIL VERIFICATION API (useEffect)
  useEffect(() => {
    verifyEmail();
  }, [token, navigate]);
 return (
    <div className="container text-center mt-5">
      {loading ? <p>Verifying your email...</p> : <p>Email Verification</p>}
    </div>
  );
}

export default EmailVerification;
